export default __webpack_public_path__ + "static/openai-logo-56c3795dbd50e664fec56b6e38d809f5.svg";